/**
 * @file
 * @prettier
 */

import { InitializeAddLoanPages } from "./AddLoanPages.js";

export function InitializeAddLoanStep1Page() {
  InitializeAddLoanPages();
}
